import { AfterViewInit, Component, OnDestroy } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-netflix-attributes',
  templateUrl: './netflix-attributes.component.html',
  styleUrls: ['./netflix-attributes.component.sass']
})
export class NetflixAttributesComponent implements AfterViewInit, OnDestroy {
  readonly spinnerName = 'netflixSpinner';

  constructor(private spinner: NgxSpinnerService) {}

  ngAfterViewInit(): void {
    this.spinner.show(this.spinnerName);
    setTimeout(() => this.spinner.hide(this.spinnerName), 0);
  }

  ngOnDestroy(): void {
    this.spinner.hide(this.spinnerName);
  }
}
